import {
  LOGIN_FORM_FORCE_LOGIN_REFRESH,
  LOGIN_FORM_RESET,
  LOGIN_USER_ERROR,
  LOGIN_USER_PENDING,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  REFRESH_LOGIN_USER
} from '../../constants';

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  token: null,
  user: {},
  hasError: false,
  isLoading: false,
  isForceRefresh: false,
});

function sessionReducer(state = INITIAL_STATE,
  action = { type: '', payload: null }) {


  switch (action.type) {

    case LOGIN_FORM_RESET:
      {
        return state.merge(fromJS({
          hasError: false,
          isLoading: false,
          isSuccess: false,
        }));
      }
    case LOGIN_USER_PENDING:
      {
        return state.merge(fromJS({
          token: null,
          user: {},
          hasError: false,
          isLoading: true,
          isSuccess: false,
        }));
      }


    case LOGIN_USER_SUCCESS:{
      return state.merge(fromJS({
        token: action.payload.token,
        user: action.payload.profile,
        hasError: false,
        isLoading: false,
        isSuccess: true,
        isForceRefresh: false,
      }));
    } 

    case LOGIN_USER_ERROR:
      return state.merge(fromJS({
        hasError: true,
        isLoading: false,
        isSuccess: false,
      }));

    case LOGIN_FORM_FORCE_LOGIN_REFRESH:
      {
        return state.merge(fromJS({
          hasError: false,
          isLoading: false,
          isSuccess: false,
          isForceRefresh: true,
        }));
      }

    case REFRESH_LOGIN_USER:
      {
        return state.merge(fromJS({
          token: action.payload.token,
          user: action.payload.profile,
          hasError: false,
          isLoading: false,
          isSuccess: true,
          isForceRefresh: false,
        }));
      }


    case LOGOUT_USER:
      {
        return state.merge(INITIAL_STATE);
      }


    default:
      return state;
  }
}

export default sessionReducer;
